import styled, { css } from 'styled-components/macro';
import { device } from 'components/styles/MediaQuery';

export interface ScErrorBlockProps {
  withBg?: boolean;
}

export const ScErrorBlock = styled.div<ScErrorBlockProps>`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  font-family: ${({ theme }) => theme.mainFontFamily}, sans-serif;
  height: 100dvh;

  .page-bg {
    position: absolute;
    display: block;
    width: 100%;
    height: 100%;
    inset: 0;
    object-fit: cover;
  }

  button {
    min-width: 200px;
  }

  p {
    position: relative;
    width: min(392px, calc(100vw - 32px));
    margin-inline: auto;
    font-weight: bold;
    font-size: 16px;
    line-height: 28px;
    text-align: center;
    letter-spacing: 0.01em;

    &.title {
      font-size: 22px;
      margin-bottom: 8px;

      @media (${device.mobile}) {
        font-size: 18px;
        line-height: 24px;
      }
    }

    &.subtitle {
      margin-bottom: 0;
      color: ${({ theme }) => theme.grayColor1};
    }
  }
  .rich-text {
    position: relative;
    text-align: center;
    padding: 32px 24px;
    border-radius: 16px;
    background-color: ${({ theme }) => theme.grayColor3};
    width: min(440px, calc(100vw - 24px));
    margin-inline: auto;
    @media (${device.tablet}) {
      padding: 24px;
    }

    & > svg {
      height: 28px;
      margin-bottom: 32px;
      @media (${device.tablet}) {
        margin-bottom: 24px;
      }
    }

    p {
      width: 100%;

      &.title {
        margin-bottom: 12px;
      }
    }
  }
  .buttonWrap {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    width: min(344px, calc(100vw - 32px));
    margin-inline: auto;
    padding-top: 32px;
    column-gap: 16px;
    @media (${device.mobile}) {
      column-gap: 8px;
    }
    * {
      min-width: auto;
      width: 100%;
    }
    & > button,
    & > a {
      width: calc(50% - 8px);
      .btn-content {
        font-size: 14px;
      }
      &.support {
        line-height: 1;
        margin-bottom: 0;
      }
      .icon {
        margin-right: 6px;
      }
      @media (${device.mobile}) {
        width: calc(50% - 4px);
      }
    }
  }
  @media (${device.tablet}) {
    ${({ withBg }) =>
      !withBg &&
      css`
        height: calc(100dvh - 45px);
      `}
  }
  @media (${device.mobile}) {
    ${({ withBg }) =>
      !withBg &&
      css`
        height: calc(100dvh - 129px);
      `}
  }
`;
